module.exports = __webpack_public_path__ + "img/multiplier_normal_1.ba5603cc.png";